import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { Navigate , Route } from "react-router-dom";
import Header  from './header'; 
import BreadCrumb from './breadcrumb';
class Register extends Component {
 
    constructor (props) {
        super (props)

        this.state = {
            limit: 5,
            hasMoreItems: true,
            fullname:'',
            username:'',
            password:''
        };

        this.handleSubmit = this.handleSubmit.bind(this); 
    }

    componentDidMount(){
        var loaderElement = document.querySelector('#load_screen');
        setTimeout( function() {
            loaderElement.style.display = "none";
        }, 3000); 
      }

    updateUsername(event){
        this.setState({username:event.target.value})
        console.log(this.state.username);

    }
    updatefullname(event){
      this.setState({fullname:event.target.value})
      console.log(this.state.fullname);

  }


    updatePassword(event){
         
        this.setState({password:event.target.value})
        console.log(this.state.password);

    }
    handleSubmit(event) {
        if(this.state.fullname.length > 0 && this.state.username.length>0){
            var loginDetails = new FormData();
            loginDetails.append('email', this.state.username);
            loginDetails.append('name', this.state.fullname);
            loginDetails.append('OP', 'createUser');
            axios.post('http://sktrading.biz/BMSCalls/users.php',loginDetails)
              .then(function (response) {
                console.log(response.data.status);
                if(response.data.status =='true'){
                  console.log(response.data.response);
                    toast.success(response.data.response, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        closeButton:false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }else{ 
                //  console.log("ELSE",response.data.response);
                    toast.error(response.data.response, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        closeButton:false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }
              })
              .catch(function (error) {
                console.log(error);
              });
        }else{
            toast.error("Insufficient Details", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                closeButton:false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
        }
      
          
        event.preventDefault();
      }
    
    render (){
      //  const {products, addToCart, symbol, addToWishlist, addToCompare} = this.props;
      return (
        <div>
              {/* BEGIN LOADER */}
        <div id="load_screen"> <div className="loader"> <div className="loader-content">
              <div className="spinner-grow align-self-center" />
            </div></div></div>
        {/*  END LOADER */}
        {/*  BEGIN NAVBAR  */}
        <Header/>
        {/*  END NAVBAR  */}
        {/*  BEGIN MAIN CONTAINER  */}
        <div className="main-container" id="container">
          <div className="overlay" />
          <div className="search-overlay" />
          {/*  BEGIN CONTENT AREA  */}
          <div id="content" className="main-content">
            <div className="layout-px-spacing">
              <BreadCrumb/>
              <div className="row layout-top-spacing layout-spacing">
                <div id="flLoginForm" className="col-lg-12 layout-spacing">
                  <div className="statbox widget box box-shadow">
                    <div className="widget-header">
                      <div className="row">
                        <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                          <h4 id="registerString">Create User</h4>
                        </div>
                      </div>
                    </div>
                    <div className="widget-content widget-content-area">
                      <form id="user_registration" onSubmit={this.handleSubmit}>
                        <div className="form-group mb-4">
                          <input type="text" defaultValue="" className="form-control" id="parent_id" placeholder="Added By:" disabled />
                        </div>
                        {/* <div className="form-group mb-4">
                          <input type="text" className="form-control" id="client_update_date" placeholder="Update Date / Time" />
                        </div> */}
                        {/* <select className="form-control  basic">
                          <option>Client Type</option>
                          <option>Buyer</option>
                          <option>Supplier</option>
                          <option>Auction</option>
                          <option>Consignee</option>
                          <option>Notifying Party</option>
                          <option>Bank</option>
                          <option>Transport Company</option>
                          <option>Agent</option>
                          <option>Shipping Company</option>
                          <option>Services</option>
                        </select> */}
                        <div className="form-group mb-4">
                          <input type="text" className="form-control" id="client_name" 
                          value={this.state.fullname}  onChange={(e) => {this.updatefullname(e)}} 
                          placeholder="User Full name" />
                        </div>
                        <div className="form-group mb-4">
                          <input type="email" className="form-control" id="client_user"
                            value={this.state.username}  onChange={(e) => {this.updateUsername(e)}} 
                           placeholder="User name / Email" />
                        </div>
                        
{/*                         
                        <select className="form-control  basic">
                          <option>Client Deals in</option>
                          <option>PKR</option>
                          <option>JPY</option>
                          <option>USD</option>
                          <option>EUR</option>
                        </select> 
                        <div className="form-group mb-4">
                          <input type="text" className="form-control" id="client_deals_in" placeholder="DEALS IN PKR" />
                        </div>
                        <div className="form-group mb-4">
                          <input type="text" className="form-control" id="client_manager" placeholder="Manager name" />
                        </div>*/}
                        <small id="emailHelp" className="form-text text-muted">*Required Fields</small>
                        <button type="submit" id="btnRegis" className="btn btn-primary mt-4">Create User</button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer-wrapper">
                <div className="footer-section f-section-1">
                  <p className>Copyright © 2021 <a target="_blank" href>YMS</a>, All rights reserved.</p>
                </div>
                <div className="footer-section f-section-2">
                  <p className>Coded with <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg></p>
                </div>
              </div>
              {/* BEGIN GLOBAL MANDATORY SCRIPTS */}
              {/* END GLOBAL MANDATORY SCRIPTS */}
              {/* BEGIN PAGE LEVEL SCRIPTS */}
              {/* END PAGE LEVEL SCRIPTS */}
            </div>
          </div>
          {/* END MAIN CONTAINER */}
        </div>
        </div>
      );
    }
}
const mapStateToProps = (state) => ({
 
})
 
export default Register; 